import { MASK_TYPES } from './MaskTypes.js';
import '@babel/runtime/helpers/esm/defineProperty';

var defaultProps = {
  autoFocus: false,
  style: {},
  disabled: false,
  className: '',
  name: '',
  maxLength: 255,
  minLength: 0,
  fluidWidth: false,
  onKeyDown: function onKeyDown() {
    return null;
  },
  onClick: function onClick() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onFocus: function onFocus() {
    return null;
  },
  onBlur: function onBlur() {
    return null;
  },
  onPaste: function onPaste() {
    return null;
  },
  onKeyUp: function onKeyUp() {
    return null;
  },
  value: '',
  hasError: false,
  readOnly: false,
  innerRef: null,
  type: 'text',
  clearable: false,
  leftComponent: null,
  rightComponent: null,
  mask: MASK_TYPES.DATE,
  pipe: null,
  useSubfix: ''
};

export { defaultProps };
//# sourceMappingURL=defaultProps.js.map
